import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DashboardService } from '../../services/dashboard.service';
import { DashboardMetrics } from '../../models/dashboard.model';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { ErrorMessagesService } from 'src/app/shared/messages/services/error-messages.service';

@Component({
  selector: 'app-chat-dashboard',
  templateUrl: './chat-dashboard.component.html',
  styleUrls: ['./chat-dashboard.component.scss']
})
export class ChatDashboardComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  
  metrics: DashboardMetrics | null = null;
  isLoading = false;
  error = '';
  erro403 = false;

  constructor(
    private dashboardService: DashboardService,
    private toastService: ToastService,
    private errorMessagesService: ErrorMessagesService
  ) {}

  ngOnInit(): void {
    this.carregarMetricas();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  carregarMetricas(): void {
    this.isLoading = true;
    this.error = '';
    
    this.dashboardService.obterMetricas()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.metrics = response.data;
          }
          this.isLoading = false;
        },
        error: (error) => {
          if (error.status === 403) {
            this.erro403 = true;
            this.isLoading = false;
            return;
          }
          this.error = this.errorMessagesService.getMessage('ERR_0008');
          this.isLoading = false;
          console.error('Erro ao carregar métricas:', error);
        }
      });
  }
}
